const allowedFramedUrls = [
  '/account/password/recover',
  '/account/userid/recover',
  '/account/reauth/verify',
  '/account/two-step-verification/verify',
  '/account/login',
  '/account/password/reset',
  '/account/authenticate',
];

export const clickableClasses = {
  _dlsIconSearch_: 'https://global.americanexpress.com/search',
};

export default allowedFramedUrls;
